export enum localStorageKeys {
  i18nextLng = 'i18nextLng',
}
